import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Login from './pages/login';
import Home from './pages/home';
import Events from './pages/events';
import Bookings from './pages/bookings';
import Categories from './pages/categories';
import Users from './pages/users';
import SupportMessages from './pages/supportMessages';
import Feedback from './pages/feedback';
import LandingContent from './pages/landingContent';
import NavigationMenu from './pages/navigationMenu';

const Path = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route path="/home" element={<Home />} />
        <Route path="/events" element={<Events />} />
        <Route path="/bookings" element={<Bookings />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/users" element={<Users />} />
        <Route path="/support-messages" element={<SupportMessages />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/landing-content" element={<LandingContent />} />
        <Route path="/navigation-menu" element={<NavigationMenu />} />

        <Route path="*" element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Path;